import React, {useEffect} from 'react'
import { useLocation } from "react-router-dom";
import Footer from '../components/Footer';
import useIsMobile from "../hooks/useIsMobile";

const Menu = ({lang, translations}) => {
    const { pathname } = useLocation();
    const isDeviceMobile = useIsMobile();

    useEffect(() => {
        window.scrollTo(0, 0); 
      }, [pathname]); 
    
  return (
    <div className='flex-column background-cream'>
    <div className='flex margin-top-15'>
      <img className={isDeviceMobile ? "width100" : 'width80'} src={lang=== 'es' ?  "img/cartaencastellano.jpg" : lang==='en' ? "img/cartaeningles.jpg" : lang==='ca' ? "img/cartaencastellano.jpg" : "img/cartaencastellano.jpg"} alt={translations[lang].cartamenualt} />
        
    </div>
    <Footer lang={lang} translations={translations}/>
    </div>
  )
}

export default Menu